import { connect } from "react-redux";
import TestsPresentationComponent from "../../components/facial-recognition/presenter";
import {
  nextTask,
  nextTest,
  setShowTaskCompletion,
  markTaskResultsStart,
  markTaskResultsEnd,
  addTaskResultDetails,
} from "../../actions/index";

const stateToProps = (state) => {
  const {
    currentTask: { testIndex },
    tasks: {
      facialRecognition: { tests },
    },
  } = state;
  return {
    tests,
    testIndex,
    timeToHit: 1.6,
  };
};

const dispatchProps = {
  nextTest,
  setShowTaskCompletion,
  markTaskResultsStart,
  markTaskResultsEnd,
  addTaskResultDetails,
};

const mergeProps = (
  stateProps,
  {
    nextTest: boundNextTest,
    setShowTaskCompletion: boundSetShowTaskCompletion,
    markTaskResultsStart: boundMarkTaskResultsStart,
    markTaskResultsEnd: boundMarkTaskResultsEnd,
    addTaskResultDetails: boundAddTaskResultDetails,
  },
  otherProps
) => {
  const { testIndex, tests } = stateProps;
  const lastTest = testIndex === tests.length - 1;
  const next = () =>
    setTimeout(
      () => {
        if (lastTest) {
          boundMarkTaskResultsEnd();
          boundSetShowTaskCompletion(true, nextTask());
        } else {
          boundNextTest();
        }
      },

      1000
    );
  const handleStart = () => boundMarkTaskResultsStart();
  const handleHit = (response, reactionTime, tapDuration) => {
    boundAddTaskResultDetails({ response, reactionTime, tapDuration });
    next();
  };

  const handleTimeout = () => {
    boundAddTaskResultDetails({
      response: "not-hit",
      reactionTime: 0,
      tapDuration: 0,
    });
    next();
  };

  return {
    ...stateProps,
    ...otherProps,
    onStart: handleStart,
    onTimeout: handleTimeout,
    onHit: handleHit,
  };
};

const FacialRecognitionPresentation = connect(
  stateToProps,
  dispatchProps,
  mergeProps
)(TestsPresentationComponent);

export default FacialRecognitionPresentation;
